// App base url will be fetched from browser of ui

// Patch Base URL
// export const APP_BASE_URL = "enterprise.qualdo.ai"

// Dev Base URL
//export const APP_BASE_URL = "dev-saas-azure.qualdo.ai"

//export const APP_BASE_URL = "qdq-eaf115aef02c11f0.gcp-qualdo.ai"


// Staging Base URL
// export const APP_BASE_URL = "stg-saas-azure.qualdo.ai"

// Instance Base URL
//export const APP_BASE_URL = "qdq-46297df6f47111f0.gcp-qualdo.ai"

export const APP_BASE_URL = window.location.hostname
export const iam_ip = APP_BASE_URL+"/iam"
export const iam_google_signup = APP_BASE_URL+"/iam"
export const ui_service_ip = APP_BASE_URL+"/ui-api-service"
export const console_ip = APP_BASE_URL+"/console"

// Powerbi base url will be fetched from env variable.
export const powerbi_service_ip = process.env.REACT_APP_POWERBI_BASE_URL+"/ui-api-service"
